/* ==========================================================================
   Modern mega dropdown menu — davranis katmani
   Tema: Milagron (Symmetry tabanli)

   Sorumluluklar:
     - Sol kategori kolonundaki sekmeler ile sag panelin degistirilmesi
     - Hover niyeti (intent) gecikmesi
     - Klavye ile gezinme (ok tuslari, Home/End, Escape) + roving tabindex
     - Dokunmatik cihazlarda ilk dokunusun sekme degistirmesi
     - Tema JS'indeki navHoverDelay degerinin ayardan beslenmesi
     - Tema editorunde blok secildiginde ilgili panelin acilmasi

   Acma/kapama isini tema JS'i (MainNavigation) yapmaya devam eder;
   burada yalnizca panel ici davranis yonetilir.
   ========================================================================== */

(function () {
  'use strict';

  var TAB_SELECTOR = '.mm-side__item[data-mm-tab]';

  /* Son girdi tipi. matchMedia('(pointer: coarse)') yalnizca BIRINCIL girdiyi
     sorgular; dokunmatik ekranli dizustunde yanlis cevap verir. */
  var lastPointerCoarse = false;

  function MegaMenu(nav) {
    this.nav = nav;
    this.hoverTimer = -1;
    this.tabDelay = parseInt(nav.getAttribute('data-mm-tab-delay') || '90', 10);
    this.bind();
  }

  MegaMenu.prototype.panesFor = function (item) {
    return item.querySelectorAll('.mm-content > .mm-pane[data-mm-pane]');
  };

  MegaMenu.prototype.tabsFor = function (item) {
    return item.querySelectorAll(TAB_SELECTOR);
  };

  MegaMenu.prototype.activate = function (tab) {
    if (!tab || tab.classList.contains('is-active')) return;

    var item = tab.closest('.navigation__item');
    if (!item) return;

    var index = tab.getAttribute('data-mm-tab');
    var tabs = this.tabsFor(item);
    var panes = this.panesFor(item);
    var i;

    for (i = 0; i < tabs.length; i += 1) {
      var isMatch = tabs[i] === tab;
      tabs[i].classList.toggle('is-active', isMatch);
      tabs[i].setAttribute('aria-selected', isMatch ? 'true' : 'false');
      /* Roving tabindex: tablist tek bir Tab duragi olur, gezinme ok tuslariyla */
      tabs[i].tabIndex = isMatch ? 0 : -1;
    }

    for (i = 0; i < panes.length; i += 1) {
      var paneMatch = panes[i].getAttribute('data-mm-pane') === index;
      panes[i].classList.toggle('is-active', paneMatch);
      if (paneMatch) {
        panes[i].removeAttribute('hidden');
      } else {
        panes[i].setAttribute('hidden', '');
      }
    }
  };

  /* Menu yeniden acildiginda ilk sekmeye don */
  MegaMenu.prototype.reset = function (item) {
    item.classList.remove('mm-force-closed');
    var tabs = this.tabsFor(item);
    if (tabs.length) this.activate(tabs[0]);
  };

  MegaMenu.prototype.close = function (item) {
    if (!item) return;
    /* Yalnizca mouseleave yetmiyor: tema main.css'te
       "body.tab-used .navigation__item--with-children:focus-within" kurali
       paneli acik tutuyor. Odak ust linke gittiginde bu kural hala eslesiyor,
       bu yuzden acikca kilitliyoruz. Sinif bir sonraki acilista temizlenir. */
    item.classList.add('mm-force-closed');
    item.dispatchEvent(new Event('mouseleave'));
    var link = item.querySelector('.navigation__link');
    if (link) link.focus();
  };

  MegaMenu.prototype.setInitialTabIndexes = function () {
    this.nav.querySelectorAll('.navigation__item--with-mega-menu').forEach(function (item) {
      item.querySelectorAll(TAB_SELECTOR).forEach(function (tab) {
        tab.tabIndex = tab.classList.contains('is-active') ? 0 : -1;
      });
    });
  };

  MegaMenu.prototype.bind = function () {
    var self = this;

    /* Hover ile sekme degistirme (kisa niyet gecikmesi ile).
       relatedTarget kontrolu: sekme icindeki ikon/etiket arasi gecislerde
       zamanlayicinin bosuna sifirlanmasini onler. */
    this.nav.addEventListener(
      'mouseover',
      function (evt) {
        if (lastPointerCoarse) return;
        var tab = evt.target.closest ? evt.target.closest(TAB_SELECTOR) : null;
        if (!tab || !self.nav.contains(tab)) return;
        if (evt.relatedTarget && tab.contains(evt.relatedTarget)) return;
        clearTimeout(self.hoverTimer);
        self.hoverTimer = setTimeout(function () {
          self.activate(tab);
        }, self.tabDelay);
      },
      true
    );

    this.nav.addEventListener(
      'mouseout',
      function (evt) {
        var tab = evt.target.closest ? evt.target.closest(TAB_SELECTOR) : null;
        if (!tab) return;
        if (evt.relatedTarget && tab.contains(evt.relatedTarget)) return;
        clearTimeout(self.hoverTimer);
      },
      true
    );

    /* Klavye odagi ile sekme degistirme */
    this.nav.addEventListener(
      'focusin',
      function (evt) {
        var el = evt.target;
        if (!el.closest) return;

        var item = el.closest('.navigation__item--with-children');
        if (item) item.classList.remove('mm-force-closed');

        var tab = el.closest(TAB_SELECTOR);
        if (tab) self.activate(tab);
      },
      true
    );

    /* Menu her acildiginda ilk sekmeye don */
    this.nav.querySelectorAll('.navigation__item--with-mega-menu').forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        self.reset(item);
      });
    });

    this.setInitialTabIndexes();

    /* Dokunmatik: pasif sekmeye ilk dokunus sekmeyi degistirir, ikincisi gider */
    this.nav.addEventListener('click', function (evt) {
      var tab = evt.target.closest ? evt.target.closest(TAB_SELECTOR) : null;
      if (!tab) return;
      var coarse = lastPointerCoarse || window.matchMedia('(hover: none)').matches;
      if (coarse && !tab.classList.contains('is-active')) {
        clearTimeout(self.hoverTimer);
        evt.preventDefault();
        self.activate(tab);
      }
    });

    /* Klavye gezinme */
    this.nav.addEventListener('keydown', function (evt) {
      var item;

      if (evt.key === 'Escape') {
        item = evt.target.closest('.navigation__item--with-children');
        if (item) {
          evt.preventDefault();
          self.close(item);
        }
        return;
      }

      var tab = evt.target.closest ? evt.target.closest(TAB_SELECTOR) : null;
      if (!tab) return;

      item = tab.closest('.navigation__item');
      var tabs = Array.prototype.slice.call(self.tabsFor(item));
      var pos = tabs.indexOf(tab);
      var next = -1;

      if (evt.key === 'ArrowDown') {
        next = (pos + 1) % tabs.length;
      } else if (evt.key === 'ArrowUp') {
        next = (pos - 1 + tabs.length) % tabs.length;
      } else if (evt.key === 'Home') {
        next = 0;
      } else if (evt.key === 'End') {
        next = tabs.length - 1;
      } else if (evt.key === 'ArrowRight' || evt.key === 'ArrowLeft') {
        var rtl = document.documentElement.getAttribute('dir') === 'rtl';
        var intoPane = rtl ? evt.key === 'ArrowLeft' : evt.key === 'ArrowRight';
        if (intoPane) {
          var pane = item.querySelector('.mm-pane.is-active');
          var first = pane && pane.querySelector('a[href]');
          if (first) {
            evt.preventDefault();
            first.focus();
          }
        }
        return;
      } else {
        return;
      }

      if (next > -1 && tabs[next]) {
        evt.preventDefault();
        self.activate(tabs[next]);
        tabs[next].focus();
      }
    });
  };

  function init() {
    var navs = document.querySelectorAll('.navigation [data-mm-nav]');
    for (var i = 0; i < navs.length; i += 1) {
      if (navs[i].megaMenu) continue;
      navs[i].megaMenu = new MegaMenu(navs[i]);
    }

    /* Tema JS'indeki hover gecikmesini ayardan besle */
    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('main-navigation').then(function () {
        document.querySelectorAll('main-navigation[data-mm-hover-delay]').forEach(function (el) {
          var delay = parseInt(el.getAttribute('data-mm-hover-delay'), 10);
          if (!Number.isNaN(delay)) el.navHoverDelay = delay;
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Belge seviyesindeki dinleyiciler yalnizca bir kez baglanir. Header bolumu
     tema editorunde yeniden yuklendiginde bu script tekrar calisir. */
  if (!window.__megaMenuGlobalBound) {
    window.__megaMenuGlobalBound = true;

    document.addEventListener(
      'pointerdown',
      function (evt) {
        lastPointerCoarse = evt.pointerType === 'touch' || evt.pointerType === 'pen';
      },
      true
    );

    document.addEventListener('shopify:section:load', function (evt) {
      if (evt.target && evt.target.classList && evt.target.classList.contains('section-header')) init();
    });

    /* Tema editorunde bir promosyon blogu secilince ilgili menu acilsin */
    document.addEventListener('shopify:block:select', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;
      if (!t.matches('.mm-card, .mm-wide')) return;
      var item = t.closest('.navigation__item--with-children');
      if (item) {
        item.classList.remove('mm-force-closed');
        item.dispatchEvent(new Event('mouseenter'));
      }
    });

    document.addEventListener('shopify:block:deselect', function (evt) {
      var t = evt.target;
      if (!t || !t.closest || !t.matches('.mm-card, .mm-wide')) return;
      var item = t.closest('.navigation__item--with-children');
      if (item) item.dispatchEvent(new Event('mouseleave'));
    });
  }
})();
